export { default as HeadingWithHighlight } from './headingWithHighlight';
export { headingWithHighlightType } from './headingWithHighlight.types';
export { headingWithHighlightFragment } from './headingWithHighlight.fragment';
export { headingWithHighlightStandard } from './__fixtures__/headingWithHighlight';
